import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { take } from 'rxjs/operators';
import { FirebaseAuthService } from './firebaseAuth.service';
import { Subscription, BehaviorSubject } from 'rxjs';

@Injectable()
export class FirebaseMessagingService {
	constructor(
		private angularFireDB: AngularFireDatabase,
		private angularFireAuth: AngularFireAuth,
		private angularFireMessaging: AngularFireMessaging,
		private firebaseAuthService: FirebaseAuthService
	) {
		// this.angularFireMessaging.messaging.subscribe((_messaging) => {
		// 	_messaging.onMessage = _messaging.onMessage.bind(_messaging);
		// 	_messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
		// });
		this.angularFireMessaging.messages.subscribe((message) => {
			console.log(message);
		});
	}

	token: string;
	messagingSubscription: Subscription;
	currentMessage: BehaviorSubject<any> = new BehaviorSubject(null);

	updateToken(id, token) {
		this.angularFireAuth.authState.pipe(take(1)).subscribe(() => {
			const data = {};
			data[token] = new Date().toISOString();
			this.angularFireDB
				.object(
					'fcmTokens/' + this.firebaseAuthService.userCredentials.user.uid + '/'
				)
				.update(data);
		});
	}

	requestPermission(uid: string) {
		this.angularFireMessaging.requestToken.subscribe(
			(token) => {
				this.token = token;
				this.updateToken(uid, token);
			},
			(err) => {
				console.error('Unable to get permission to notify.', err);
			}
		);
	}

	receiveMessage() {
		this.messagingSubscription = this.angularFireMessaging.messages.subscribe(
			(payload) => {
				console.debug('Nuevo mensaje recibido: ', payload);
				this.currentMessage.next(payload);
			}
		);
	}

	getToken() {
		return this.angularFireMessaging.getToken;
	}

	deleteToken() {
		this.angularFireMessaging
			.deleteToken(this.token)
			.subscribe((result) => console.debug('Token FCM borrado'));
	}
}
